/*
 *   File : add-nominee-card.js
 *   Author : https://evoqins.com
 *   Description : Nominee details card component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import { useEffect, useState, memo } from 'react';
import { differenceInYears, subDays, format } from 'date-fns';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//custom component
import { CustomPhoneInput, CustomTextInput, DatePicker } from '../Form-Elements';
import { SelectionSuggestModal } from '../Modal';
import { _formatDateFormat } from '../../Helper';
import { APIService } from '../../Service';

// *********** Assets ***************//  
import Inactive from "../../Assets/Images/check-box.svg";
import ActiveCheckbox from "../../Assets/Images/check-box-active.svg";

const AddNomineeCard = (props) => {

    const ID_PROOF = props.data.nominee_identity_proof;
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [selectedRelation, setSelectedRelation] = useState([]);
    const [relationError, setRelationError] = useState("");

    const [allocation, setAllocation] = useState("");
    const [allocationError, setAllocationError] = useState("");

    const [dob, setDob] = useState("");
    const [dobError, setDobError] = useState("");

    const [relationData, setRelationData] = useState(props.data);

    const [guardianName, setGuardianName] = useState("");
    const [guardianNameError, setGuardianNameError] = useState("");

    const [selectedGuardianRelation, setSelectedGuardianRelation] = useState([]);
    const [guardianRelationError, setGuardianRelationError] = useState("");

    const IS_MINOR = differenceInYears(new Date(), new Date(dob)) < 18;

    const [initialStatus, setInitialStatus] = useState(true);

    const [showRelationModal, setShowRelationModal] = useState(false);
    const [showGuardianRelationModal, setShowGuardianRelationModal] = useState(false);


    // New Data
    const [idProofNo, setIdProofNo] = useState("");
    const [idProofNoError, setIdProofNoError] = useState("");
    const [selectedIDProof, setSelectedIDProof] = useState([]);
    const [selectedIDProofError, setSelectedIDProofError] = useState("");

    const [phone, setPhone] = useState("");
    const [selectedCountryCode, setSelectedCountryCode] = useState("+91");
    const [selectedCountryLocale, setSelectedCountryLocale] = useState("IN");
    const [phoneError, setPhoneError] = useState("");
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [showIDProofModal, setShowIDProofModal] = useState(false);

    const [countryData, setCountryData] = useState(props.countryData.countries_for_address);
    const [country, setCountry] = useState([]);
    const [countryError, setCountryError] = useState("");
    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [address, setAddress] = useState("");
    const [addressError, setAddressError] = useState("");
    const [secondAddress, setSecondAddress] = useState("");
    const [secondAddressError, setSecondAddressError] = useState("");
    const [selectedState, setSelectedState] = useState([]);
    const [stateError, setStateError] = useState("");
    const [selectedCity, setSelectedCity] = useState([]);
    const [cityError, setCityError] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [pinCodeError, setPinCodeError] = useState("");


    const [showCountryModal, setShowCountryModal] = useState(false);
    const [showStateModal, setShowStateModal] = useState(false);
    const [showCityModal, setShowCityModal] = useState(false);
    const [nomineeType, setNomineeType] = useState(IS_MINOR ? 'guardian' : 'nominee');
    const [guardianIDProof, setGuardianIDProof] = useState([]);
    const [guardianProofNo, setGuardianProofNo] = useState('');
    const [guardianProofError, setGuardianProofError] = useState('');
    const [guardianCountry, setGuardianCountry] = useState([]);
    const [guardianCountryError, setGuardianCountryError] = useState("");
    const [guardianAddress, setGuardianAddress] = useState("");
    const [guardianAddressError, setGuardianAddressError] = useState("");
    const [guardianSecondAddress, setGuardianSecondAddress] = useState("");
    const [guardianSecondAddressError, setGuardianSecondAddressError] = useState("");
    const [selectedGuardianState, setSelectedGuardianState] = useState([]);
    const [selectedGuardianCity, setSelectedGuardianCity] = useState([]);
    const [guardianCityError, setGuardianCityError] = useState("");
    const [guardianPinCode, setGuardianPinCode] = useState("");
    const [guardianPinCodeError, setGuardianPinCodeError] = useState("");
    const [guardianPhone, setGuardianPhone] = useState("");
    const [guardianPhoneError, setGuardianPhoneError] = useState("");
    const [selectedGuardianCountryCode, setSelectedGuardianCountryCode] = useState("+91");
    const [selectedGuardianCountryLocale, setSelectedGuardianCountryLocale] = useState("IN");
    const [guardianEmail, setGuardianEmail] = useState("");
    const [guardianEmailError, setGuardianEmailError] = useState("");
    const [selectedGuardianStateError, setSelectedGuardianStateError] = useState("");
    const [selectedGuardianIdProofError, setSelectedGuardianIdProofError] = useState("");
    const [nomineeId, setNomineeId] = useState(null);

    const [proofLabel, setProofLabel] = useState("Identity document number*");
    const [proofLabelGuardian, setProofLabelGuardian] = useState("Guardian ID no.*");

    const [hasSameAddress, setHasSameAddress] = useState(true);

    useEffect(() => {
        // Address details
        _getState();
    }, []);


    // Prefilling already entered data
    useEffect(() => {

        // Not wrapping with any condition to re-fill the entered data previously
        if (props.nomineeData?.nominee_id !== null) {
            setNomineeId(props.nomineeData.nominee_id);
        }
        if (props.nomineeData?.name !== null) {
            setName(props.nomineeData.name);
        }
        if (props.nomineeData.dob !== null) {
            setDob(_formatDateFormat(props.nomineeData.dob));
        };

        if (props.nomineeData?.allocation !== null) {
            setAllocation(props.nomineeData.allocation);
        } else {
            setAllocation(100);
        }

        if (props.nomineeData?.guardian_name !== null) {
            setGuardianName(props.nomineeData.guardian_name);
        }

        if (props.nomineeData?.relation_id !== null) {
            let selected_relation = props.data?.kyc_relationship?.find((data) => data.id == props.nomineeData.relation_id);
            setSelectedRelation(selected_relation);
        } else {
            setSelectedRelation(props.data?.kyc_relationship?.find(data => data.name === "Spouse"));
        }

        if (props.data && props.data.nominee_minor_relation) {

            if (props.nomineeData?.guardian_relationship_id !== null) {
                let selected_guardian = props.data?.nominee_minor_relation?.find((data) => data.id == props.nomineeData.guardian_relationship_id);
                setSelectedGuardianRelation(selected_guardian);
            }
        };

        if (props.nomineeData?.identity_proof_number) {
            setIdProofNo(props.nomineeData.identity_proof_number);
        }

        if (props.nomineeData?.identity_proof_type) {

            let selected_id_proof = ID_PROOF.find(item => item.id === props.nomineeData.identity_proof_type);
            setSelectedIDProof(selected_id_proof);


            if (props.nomineeData.identity_proof_type_text === "Aadhaar") {
                setProofLabel("Aadhaar(Last 4 Digit)");
            } else if (props.nomineeData.identity_proof_type_text === "Driving licence") {
                setProofLabel("Driving licence no");
            } else if (props.nomineeData.identity_proof_type_text === "Pan") {
                setProofLabel("Pan number");
            } else if (props.nomineeData.identity_proof_type_text === "Passport") {
                setProofLabel("Passport no");
            }

        } else {
            let selected_id_proof = ID_PROOF.find(item => item.name === "aadhaar");
            setSelectedIDProof(selected_id_proof);
            setProofLabel("Aadhaar(Last 4 Digit)");
        }



        if (props.nomineeData?.contact_detail?.phone_number) {
            setPhone(props.nomineeData.contact_detail?.phone_number);
            setSelectedCountryCode(props.nomineeData.contact_detail?.country_code);
        } else {
            let user_data = props.kycData.kyc_data;
            setPhone(user_data?.mobile?.country_code + user_data?.mobile?.number);
            setSelectedCountryCode(user_data?.mobile?.country_code);
        }

        if (props.nomineeData?.contact_detail?.email) {
            setEmail(props.nomineeData.contact_detail?.email);
        } else {
            let user_data = props.kycData?.kyc_data;
            setEmail(user_data?.email);
        }


        if (props.nomineeData?.nominee_address?.country) {
            setCountry({ id: props.nomineeData?.nominee_address?.country_id, name: props.nomineeData?.nominee_address?.country });
        }

        if (props.nomineeData?.nominee_address?.address_line1) {
            setAddress(props.nomineeData?.nominee_address?.address_line1);
        }

        if (props.nomineeData?.nominee_address?.country_id === 251) {
            if (props.nomineeData?.nominee_address?.state_id !== null) {
                setSelectedState({ id: props.nomineeData?.nominee_address?.state_id, name: props.nomineeData?.nominee_address?.state_name });
            }
        } else {
            setSelectedState(props.nomineeData?.nominee_address?.state_name || "");
        }

        if (props.nomineeData?.nominee_address?.country_id === 251) {
            if (props.nomineeData?.nominee_address?.city !== null) {
                setSelectedCity({ id: props.nomineeData?.nominee_address?.city_id, name: props.nomineeData?.nominee_address?.city });
            }
        } else {
            setSelectedCity(props.nomineeData?.nominee_address?.city || "");
        }



        if (props.nomineeData?.nominee_address?.pincode) {
            setPinCode(props.nomineeData?.nominee_address?.pincode);
        }

        if (props.nomineeData?.guardian_id_proof_number) {
            setGuardianProofNo(props.nomineeData?.guardian_id_proof_number);
        }

        if (props.nomineeData?.guardian_id_proof_type) {

            let selected_id_proof = ID_PROOF.find(item => item.id === props.nomineeData.guardian_id_proof_type);
            setGuardianIDProof(selected_id_proof);

            if (props.nomineeData.guardian_id_proof_type_text === "Aadhaar") {
                setProofLabelGuardian("Aadhaar(Last 4 Digit)");
            } else if (props.nomineeData.guardian_id_proof_type_text === "Driving licence") {
                setProofLabelGuardian("Driving licence no");
            } else if (props.nomineeData.guardian_id_proof_type === "Pan") {
                setProofLabelGuardian("Pan number");
            } else if (props.nomineeData.guardian_id_proof_type_text === "Passport") {
                setProofLabelGuardian("Passport no");
            }

        }
        if (props.nomineeData?.guardian_contact_detail?.phone_number !== null) {
            setGuardianPhone(props.nomineeData?.guardian_contact_detail?.phone_number);
            setSelectedGuardianCountryCode(props.nomineeData?.guardian_contact_detail?.country_code);
        } else {
            let user_data = props.kycData.kyc_data;
            setGuardianPhone(user_data?.mobile?.country_code + user_data?.mobile?.number);
            setSelectedGuardianCountryCode(user_data?.mobile?.country_code);
        }

        if (props.nomineeData?.guardian_contact_detail?.country_code !== null) {
            setSelectedGuardianCountryCode(props.nomineeData?.guardian_contact_detail?.country_code);
        }

        if (props.nomineeData?.guardian_contact_detail?.email !== null) {
            setGuardianEmail(props.nomineeData?.guardian_contact_detail?.email);
        } else {
            let user_data = props.kycData.kyc_data;
            setGuardianEmail(user_data?.email);
        }


        if (props.nomineeData?.guardian_address?.country !== null) {
            setGuardianCountry({ id: props.nomineeData?.guardian_address?.country_id, name: props.nomineeData?.guardian_address?.country })
        }

        if (props.nomineeData?.guardian_address?.address_line1) {
            setGuardianAddress(props.nomineeData?.guardian_address?.address_line1);
        }

        if (props.nomineeData?.guardian_address?.city_id !== null) {
            setSelectedGuardianCity({ id: props.nomineeData?.guardian_address?.city_id, name: props.nomineeData?.guardian_address?.city })
        } else if (props.nomineeData?.guardian_address?.country_id !== 251) {
            setSelectedGuardianCity(props.nomineeData?.guardian_address?.city || "");
        }

        if (props.nomineeData?.guardian_address?.state_id !== null) {
            setSelectedGuardianState({ id: props.nomineeData?.guardian_address?.state_id, name: props.nomineeData?.guardian_address?.state_name })
        } else if (props.nomineeData?.guardian_address?.country_id !== 251) {
            setSelectedGuardianState(props.nomineeData?.guardian_address?.state_name || "");
        }

        if (props.nomineeData?.guardian_address?.pincode) {
            setGuardianPinCode(props.nomineeData?.guardian_address?.pincode);
        }

        setInitialStatus(false);

    }, [props.nomineeData]);

    useEffect(() => {

        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_pan = /^[A-Z]{3}P[A-Z]{1}\d{4}[A-Z]{1}$/; // validation of PAN

        if (name == "") {
            setNameError(props.error?.name_error);
        };

        if (selectedRelation.length === 0) {
            setRelationError(props.error?.relation_id_error);
        };

        if (allocation == "") {
            setAllocationError(props.error?.allocation_error);
        }

        if (dob == "") {
            setDobError(props.error?.dob_error);
        }

        if (idProofNo === "") {
            setIdProofNoError(props.error.id_proof_no_error);
        } else if (selectedIDProof?.name === "pan" && !validate_pan.test(idProofNo)) { // Pan validation
            setIdProofNoError(props.error.id_proof_no_error);
        } else if (selectedIDProof?.name === "aadhaar" && idProofNo.length < 4) { // Aadhaar Validation
            setIdProofNoError(props.error.id_proof_no_error);
        };

        if (selectedIDProof?.length === 0) {
            setSelectedIDProofError(props.error.selected_proof_id_error);
        }


        if (IS_MINOR === false) {

            if (phone === "" || (phone?.replace(selectedCountryCode, "").replace("+", "").length !== 10 && selectedCountryCode === "+91")) {
                setPhoneError(props.error.mobile_number_error);
            }

            if (email === "" || !validate_email.test(email)) {
                setEmailError(props.error.email_error);
            }
        }

        if (props.error && IS_MINOR) {
            if (guardianName == "") {
                setGuardianNameError(props.error.guardian_name_error);
            };

            if (selectedGuardianRelation.length === 0) {
                setGuardianRelationError(props.error.guardian_relationship_id_error);
            };

            if (guardianProofNo == "") {
                setGuardianProofError(props.error.guardian_id_no_error);
            } else if (guardianIDProof?.name === "pan" && !validate_pan.test(guardianProofNo)) { // Pan validation
                setGuardianProofError(props.error.guardian_id_no_error);
            } else if (guardianIDProof?.name === "aadhaar" && guardianProofNo.length < 4) { // Aadhaar validation
                setGuardianProofError(props.error.guardian_id_no_error);
            };

            if (guardianIDProof == "") {
                setSelectedGuardianIdProofError(props.error.guardian_id_type_error);
            }

            if (guardianPhone === "" || (guardianPhone?.replace(selectedGuardianCountryCode, "").replace("+", "").length !== 10 && selectedGuardianCountryCode === "+91")) {
                setGuardianPhoneError(props.error.guardian_mobile_number_error);
            }

            if (guardianEmail == "" || !validate_email.test(guardianEmail)) {
                setGuardianEmailError(props.error.guardian_email_error);
            }

            if (guardianCountry.length === 0) {
                setGuardianCountryError(props.error.nationality_error)
            }

            if (guardianAddress === "") {
                setGuardianAddressError(props.error.address_error)
            }

            if (guardianSecondAddress === "") {
                setGuardianSecondAddressError(props.error.address2_error)
            }

            if (selectedGuardianState.length === 0 || selectedGuardianState?.id === null) {
                setSelectedGuardianStateError(props.error.state_error)
            }

            if (selectedGuardianCity.length === 0 || selectedGuardianCity?.id === null) {
                setGuardianCityError(props.error.city_error);
            }

            if (guardianPinCode === "") {
                setGuardianPinCodeError(props.error.pincode_error)
            }

        };

        // Address details
        if (country.length === 0) {
            setCountryError(props.error.nationality_error)
        }

        if (address === "") {
            setAddressError(props.error.address_error)
        }

        if (secondAddress === "") {
            setSecondAddressError(props.error.address2_error)
        }

        if (selectedState.length === 0 || selectedState?.id === null) {
            setStateError(props.error.state_error)
        }

        if (selectedCity.length === 0 || selectedCity?.id === null) {
            setCityError(props.error.city_error)
        }

        if (pinCode === "") {
            setPinCodeError(props.error.pincode_error)
        }

    }, [props, IS_MINOR]);


    useEffect(() => {
        if (props.fetchNominee === true) {

            let selected_id_proof_id = selectedIDProof?.id;
            let selected_guardian_id_proof_id = guardianIDProof?.id;

            let nominee = {
                "id": props.nomineeData?.id,
                "nominee_id": nomineeId || null,
                "name": name.length !== 0 ? name : null,
                "relation_id": selectedRelation?.length !== 0 ? selectedRelation.id : null,
                "relation": selectedRelation?.length !== 0 ? selectedRelation.name : null,
                "dob": dob?.length !== 0 ? format(dob, "dd-MM-yyyy") : null,
                "allocation": allocation?.length !== 0 ? Number(allocation) : null,
                "guardian_name": IS_MINOR && guardianName?.length !== 0 && IS_MINOR ? guardianName : null,
                "guardian_relationship_id": IS_MINOR && selectedGuardianRelation?.id ? selectedGuardianRelation.id : null,
                "guardian_relationship": IS_MINOR && selectedGuardianRelation?.name ? selectedGuardianRelation.name : null,
                "guardian_id_proof_type": IS_MINOR && guardianIDProof?.length !== 0 ? guardianIDProof.id : null,
                "guardian_id_proof_type_name": IS_MINOR && guardianIDProof?.length !== 0 ? guardianIDProof.name : null,
                "guardian_id_proof_number": IS_MINOR && guardianProofNo?.length !== 0 ? guardianProofNo : null,
                "guardian_address": {
                    "address_line1": IS_MINOR === false ? null : guardianAddress?.length ? guardianAddress : null,
                    "address_line2": IS_MINOR === false ? null : guardianSecondAddress?.length ? guardianSecondAddress : null,
                    "state_id": selectedGuardianState?.id ? selectedGuardianState.id : null,
                    "state_name": selectedGuardianState?.name ? selectedGuardianState.name : selectedGuardianState.length ? selectedGuardianState : null,
                    "city": selectedGuardianCity?.name ? selectedGuardianCity.name : selectedGuardianCity.length ? selectedGuardianCity : null,
                    "city_id": selectedGuardianCity?.id ? selectedGuardianCity.id : null,
                    "pincode": IS_MINOR === false ? null : guardianPinCode?.length !== 0 ? guardianPinCode : null,
                    "country_id": IS_MINOR === false ? null : guardianCountry?.length !== 0 ? (guardianCountry.id || null) : null,
                    "country": IS_MINOR === false ? null : guardianCountry?.length !== 0 ? (guardianCountry.name || null) : null
                },
                "guardian_contact_detail": {
                    "email": IS_MINOR === false ? null : guardianEmail ? guardianEmail : null,
                    "country_code": IS_MINOR ? (guardianPhone ? selectedGuardianCountryCode : null) : null,
                    "phone_number": guardianPhone ? guardianPhone.replace(selectedGuardianCountryCode, "").replace("+", "") : null // Ignoring extra +
                },
                "identity_proof_type": IS_MINOR ? null : selectedIDProof?.length !== 0 ? selectedIDProof?.id : null,
                "identity_proof_type_name": IS_MINOR ? null : selectedIDProof?.length !== 0 ? selectedIDProof?.name : null,
                "identity_proof_number": IS_MINOR ? null : idProofNo?.length !== 0 ? idProofNo : null,
                "nominee_address": {
                    "address_line1": IS_MINOR ? null : address?.length !== 0 ? address : null,
                    "address_line2": IS_MINOR ? null : secondAddress?.length !== 0 ? secondAddress : null,
                    "state_id": selectedState?.id ? selectedState.id : null,
                    "state_name": selectedState?.name ? selectedState.name : selectedState.length ? selectedState : null,
                    "city": selectedCity?.name ? selectedCity.name : selectedCity.length ? selectedCity : null,
                    "city_id": selectedCity?.id ? selectedCity.id : null,
                    "pincode": IS_MINOR ? null : pinCode?.length !== 0 ? pinCode : null,
                    "country_id": IS_MINOR ? null : country?.length !== 0 ? (country.id || null) : null,
                    "country": IS_MINOR ? null : country?.length !== 0 ? (country.name || null) : null,
                },
                "contact_detail": {
                    "email": IS_MINOR ? null : (email || null),
                    "country_code": IS_MINOR ? null : phone ? (selectedCountryCode || null) : null,
                    "phone_number": IS_MINOR ? null : phone ? phone.replace(selectedCountryCode, "").replace("+", "") : null // Ignoring extra +
                },
                "has_same_address": hasSameAddress,
            }

            props.getNomineeData(nominee, props.index, selected_id_proof_id, selected_guardian_id_proof_id);
        }

    }, [props.fetchNominee]);

    useEffect(() => {

        if ((selectedState.id || selectedGuardianState.id) && cityData.length === 0) {
            _getCity(selectedState.id || selectedGuardianState.id);
        };

    }, [selectedState, selectedGuardianState, cityData]);

    useEffect(() => {

        if (showRelationModal === true) {
            let relation_modal = new Modal(document.getElementById(`select-suggest-modal${props.index}`));
            relation_modal.show();
        };

        if (showGuardianRelationModal) {
            let guardian_relation = new Modal(document.getElementById(`select-guardian-relation${props.index}`));
            guardian_relation.show();
        };

        if (showIDProofModal) {
            let id_proof = new Modal(document.getElementById(`select-id-proof-${props.index}`));
            id_proof.show();
        };

        if (showCountryModal) {
            let country = new Modal(document.getElementById(`nominee-country-modal-${props.index}`));
            country.show();
        }

    }, [showRelationModal, showGuardianRelationModal, showIDProofModal, showCountryModal]);


    useEffect(() => {
        if (showStateModal) {
            let state = new Modal(document.getElementById(`nominee-state-modal-${props.index}`));
            state.show();
        }
    }, [showStateModal]);

    useEffect(() => {
        if (showCityModal) {
            let city = new Modal(document.getElementById(`nominee-city-modal-${props.index}`));
            city.show();
        }
    }, [showCityModal]);

    useEffect(() => {
        if (props.data) {
            setRelationData(props.data);
        }
    }, [props.data]);

    useEffect(() => {
        setCountryData(props.countryData.countries_for_address);
    }, [props.countryData]);

    //handle nominee name change
    const _handleNameChange = (value) => {
        setName(value);
        setNameError("");
    };

    //handle select relation
    const _handleSelectRelation = (value) => {
        setSelectedRelation(value);
        setRelationError("");
    };

    const _handleIDProofNumberChange = (value, minor = false) => {

        if (minor === true) {
            setGuardianProofError("");
            if (guardianIDProof.name === "pan") {
                if (value.length <= 10) {
                    setGuardianProofNo(value.toUpperCase());
                }
            } else {
                setGuardianProofNo(value);
            }
        } else {

            setIdProofNoError("");

            if (selectedIDProof.name === "pan") {
                if (value.length <= 10) {
                    setIdProofNo(value.toUpperCase());
                }
            } else {
                setIdProofNo(value);
            }
        }

    };

    //handle select ID proof
    const _handleSelectIDProof = (value) => {
        if (nomineeType === 'nominee') {

            setSelectedIDProof(value);
            setIdProofNo("");
            setIdProofNoError("");
            setSelectedIDProofError("");

            if (value.name === "aadhaar") {
                setProofLabel("Aadhaar(Last 4 Digit)");
            } else if (value.name === "driving_licence") {
                setProofLabel("Driving Licence no");
            } else if (value.name === "pan") {
                setProofLabel("Pan number");
            } else if (value.name === "passport") {
                setProofLabel("Passport no");
            }


        } else {
            setGuardianIDProof(value);
            setGuardianProofNo("");
            setGuardianProofError("");
            setSelectedGuardianIdProofError("");

            if (value.name === "aadhaar") {
                setProofLabelGuardian("Aadhaar(Last 4 Digit)");
            } else if (value.name === "driving_licence") {
                setProofLabelGuardian("Driving Licence no");
            } else if (value.name === "pan") {
                setProofLabelGuardian("Pan number");
            } else if (value.name === "passport") {
                setProofLabelGuardian("Passport no");
            }

        }



    };

    const _handleAllocationChange = (value) => {
        let allocation = value ? Number(value) : null;
        if (allocation <= 100) {
            setAllocation(value);
            setAllocationError("");
        }
    };

    //handle change date
    const _handleDateChange = (date) => {
        setDob(date);
        setDobError("");


        let is_minor = differenceInYears(new Date(), new Date(date)) < 18;
        let reset = { id: null, name: "" };

        if (is_minor !== IS_MINOR) {
            setGuardianAddress("");
            setGuardianSecondAddress("");
            setAddress("");
            setSecondAddress("");
            setCountry([]);
            setGuardianCountry([]);

            if (country?.id === 251 || Array.isArray(country)) {
                setSelectedState(reset);
                setSelectedCity(reset);
            } else {
                setSelectedCity("");
                setSelectedState("");
            }

            if (guardianCountry?.id === 251 || Array.isArray(guardianCountry)) {
                setSelectedGuardianState(reset);
                setSelectedGuardianCity(reset);
            } else {
                setSelectedGuardianState("");
                setSelectedGuardianCity("");
            }
        }


    };

    const _handleGuardianNameChange = (value) => {
        setGuardianName(value);
        setGuardianNameError("");
    };

    const _handleShowRelationModal = () => {
        setShowRelationModal(true);
    };

    const _handleShowGuardianRelationModal = () => {
        setShowGuardianRelationModal(true);
    };

    const _handleShowCountryModal = (type = 'nominee') => {
        setNomineeType(type);
        setShowCountryModal(true);
    };


    //handle select guardian relation
    const _handleSelectGuardianRelation = (value) => {
        setSelectedGuardianRelation(value);
        setGuardianRelationError("");
    };


    // handle phone number change
    const _handlePhoneNumberChange = (value, selected_country_code, country_locale, minor = false) => {
        if (minor === true) {
            setGuardianPhone(value);
            setGuardianPhoneError("");

            if (selected_country_code) {
                setSelectedGuardianCountryCode(selected_country_code)
            }

            if (country_locale) {
                setSelectedGuardianCountryLocale(country_locale);
            }

            let phone_number = value ? value.replace((selected_country_code || selectedGuardianCountryCode), "").replace("+", "") : null // Ignoring extra +

        } else {
            setPhone(value);
            setPhoneError("");
            if (selected_country_code) {
                setSelectedCountryCode(selected_country_code);
            }

            if (country_locale) {
                setSelectedCountryLocale(country_locale);
            }

            let phone_number = value ? value.replace((selected_country_code || selectedCountryCode), "").replace("+", "") : null // Ignoring extra +
        }

    };

    //handle email change
    const _handleEmailChange = (value, minor) => {
        if (minor) {
            setGuardianEmail(value.toLowerCase());
            setGuardianEmailError("")
        } else {
            setEmail(value.toLowerCase());
            setEmailError("");
        }
    };

    //handle address change 
    const _handleAddressChange = (value, minor) => {
        if (minor === true) {
            setGuardianAddress(value)
        } else {
            setAddress(() => value);
        }
        setGuardianAddressError("");
        setAddressError("");
    };

    //handle address change 
    const _handleSecondAddressChange = (value, minor) => {
        if (minor === true) {
            setGuardianSecondAddress(value)
        } else {
            setSecondAddress(() => value);
        }
        setGuardianSecondAddressError("");
        setSecondAddressError("");
    };

    //handle  Nation
    const _handleSelectNomineeNation = (value) => {

        if (nomineeType === 'nominee') {
            if (value.id !== country?.id) {
                setCountry(value);
                setCountryError("");


                if (country.length !== 0) {
                    setStateError("");
                    setCityError("");
                    setPinCode("");
                    setPinCodeError("");
                    // setAddress("");
                    // setAddressError("");
                }

                if (value.id === 251) {
                    let reset = { id: null, name: "" };
                    setSelectedState(reset);
                    setSelectedCity(reset);
                } else {
                    setSelectedState("");
                    setSelectedCity("");
                }


            }

        } else {

            if (value.id !== guardianCountry?.id) {
                setGuardianCountry(value);
                setGuardianCountryError("");


                if (guardianCountry.length !== 0) {

                    setSelectedGuardianStateError("");
                    setGuardianCityError("");
                    setGuardianPinCodeError("");
                    setGuardianPinCode("");
                    // setGuardianAddress("");
                    // setGuardianAddressError("");
                }

                if (value.id === 251) {
                    let reset = { id: null, name: "" };
                    setSelectedGuardianCity(reset);
                    setSelectedGuardianState(reset);
                } else {
                    setSelectedGuardianCity("");
                    setSelectedGuardianState("");
                }

                setGuardianPinCode("");
                // setGuardianAddress("");
            }

        }
    };

    //handle select state
    const _handleSelectState = (value) => {
        if (nomineeType === 'nominee') {
            setSelectedState(value);
            setStateError("");
            // clearing city when state changes
            setSelectedCity({ id: null, name: "" });
            setPinCode("");
        } else {
            setSelectedGuardianState(value);
            setSelectedGuardianStateError("");
            // clearing city when state changes
            setSelectedGuardianCity({ id: null, name: "" });
            setGuardianPinCode("");
        }

        setCityData([]);

    };

    //handle select city
    const _handleSelectCity = (value) => {
        if (nomineeType === 'nominee') {
            setSelectedCity(value);
        } else {
            setSelectedGuardianCity(value);
        }
        setGuardianCityError("");
        setCityError("");
        setPinCode("");
    };

    // handle change state 
    const _handleChangeState = (value) => {
        if (IS_MINOR) {
            setSelectedGuardianState(value);
        } else {
            setSelectedState(value);
        }

        setStateError("");
        setSelectedGuardianStateError("");
    };

    // handle change state 
    const _handleChangeCity = (value) => {
        if (IS_MINOR) {
            setSelectedGuardianCity(value);
        } else {
            setSelectedCity(value);
        }

        setGuardianCityError("");
        setCityError("");
    };

    const _handlePinChange = (value, minor) => {

        setNomineeType(minor);
        if (minor === 'nominee') {
            setPinCode(value.toUpperCase());
            setPinCodeError("");
        } else {
            setGuardianPinCode(value.toUpperCase())
            setGuardianPinCodeError("");
        }
    };


    const _showProofModal = (type) => {
        setNomineeType(type);
        setShowIDProofModal(true)
    }

    const _openStateModal = (type) => {
        setNomineeType(type);
        setShowStateModal(true);
    }

    const _openCityModal = (type) => {
        setNomineeType(type);
        setShowCityModal(true);
    };

    // handle has same address              
    const _handleHasSameAddress = () => {
        setHasSameAddress(prev => !prev);
    };


    //==================================== //
    //=========== API CAllS ============== //

    //API- Get state
    const _getState = () => {
        let is_post = false;
        let url = 'general/states';
        let data = null;

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setStateData(response.data);
            } else {
                setStateData([]);
                // If we don't have state data
                // User cannot continue further
                toast.dismiss();
                toast.error("We are facing issue in fetching state data. Please try later", { className: "e-toast" });
            }
        });
    };

    //API- Post City
    const _getCity = (state_id) => {
        let is_post = true;
        let url = 'general/cities';
        let data = {
            "state_id": state_id,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setCityData(response.data);
            } else {
                setCityData([]);
                toast.dismiss();
                toast.error("We are facing issue in fetching city data. Please try later", { className: "e-toast" });
            }

        });
    };

    return (
        <>

            {
                initialStatus === false &&
                <>
                    <div className={`${props.type == 2 ? "row row-cols-2 justify-content-between" : "row  gx-gy-32px"}`}>

                        {/* Nominee Detail */}
                        {/* Nominee name */}
                        <div className="col-sm-6 col-lg-4">
                            <div id={`name-${props.index}`}>
                                <CustomTextInput label="Name as per PAN*"
                                    placeholder="Joseph Thomas"
                                    type="text"
                                    floatingLabel
                                    value={name}
                                    errorMsg={nameError}
                                    handleChange={_handleNameChange} />
                            </div>
                        </div>

                        {/* Relationship */}
                        <div className="col-sm-6 col-lg-4">
                            <div id={`relation-${props.index}`}
                                className='position-relative'>
                                <CustomTextInput label="Relation*"
                                    placeholder="Select relation"
                                    dropdown={true}
                                    type="text"
                                    floatingLabel
                                    isOpen={showRelationModal}
                                    value={selectedRelation.display_name}
                                    errorMsg={relationError}
                                    readOnly
                                    onClick={() => _handleShowRelationModal()} />
                            </div>
                        </div>

                        {/* Date picker */}
                        <div className="col-sm-6 col-lg-4">
                            <div id={`dob-${props.index}`}>
                                <DatePicker value={dob}
                                    label="Date of birth*"
                                    error={dobError}
                                    floatingLabel
                                    activeDate={subDays(new Date(), 1)}
                                    maxDate={subDays(new Date(), 1)}
                                    onChange={_handleDateChange} />
                            </div>
                        </div>


                        {/* allocation*/}
                        <div className="col-sm-6 col-lg-4">
                            <div id={`allocation-${props.index}`}>
                                <CustomTextInput label="Allocation*"
                                    placeholder="Eg:50%"
                                    type="number"
                                    floatingLabel
                                    maxLength={3}
                                    maxValue={100}
                                    value={allocation}
                                    errorMsg={allocationError}
                                    handleChange={_handleAllocationChange} />
                            </div>
                        </div>


                        {
                            IS_MINOR === false &&
                            <>
                                {/* ID Proof type */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`id-proof-type-${props.index}`}>
                                        <CustomTextInput label="Select identity document*"
                                            placeholder="Select identity document "
                                            dropdown={true}
                                            type="text"
                                            floatingLabel
                                            isOpen={showIDProofModal}
                                            value={selectedIDProof?.display_name}
                                            errorMsg={selectedIDProofError}
                                            readOnly
                                            onClick={() => _showProofModal('nominee')} />
                                    </div>
                                </div>

                                {/* ID Proof No */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`id-proof-number-${props.index}`}>
                                        <CustomTextInput label={proofLabel}
                                            placeholder="Eg:BZTPN7362A."
                                            type={selectedIDProof?.name === "aadhaar" ? "number" : "text"}
                                            maxLength={selectedIDProof?.name === "aadhaar" ? 4 : 20}
                                            value={idProofNo}
                                            floatingLabel
                                            errorMsg={idProofNoError}
                                            handleChange={_handleIDProofNumberChange} />
                                    </div>
                                </div>

                                {/* Phone number */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`phone-number-${props.index}`}>
                                        <CustomPhoneInput label="Mobile number*"
                                            id={`nominee-phone-input-${props.index}`}
                                            placeholder="9876543210"
                                            className={phone ? `e-number-input-padding w-100 ` : `e-number-input-padding w-100`}
                                            type="text"
                                            floatingLabel
                                            noScrollId={props.type}
                                            value={phone}
                                            selectedCountryCode={selectedCountryCode}
                                            selectedCountryLocale={selectedCountryLocale}
                                            error={phoneError}
                                            handleChange={(value, selected_country_code, country_locale) => _handlePhoneNumberChange(value, selected_country_code, country_locale, false)} />
                                    </div>
                                </div>

                                {/* Email ID */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`email-${props.index}`} className="mb-sm-2">
                                        <CustomTextInput label="Email*"
                                            placeholder="joedoe@gmail.com"
                                            type="text"
                                            floatingLabel
                                            value={email}
                                            errorMsg={emailError}
                                            handleChange={_handleEmailChange} />
                                    </div>
                                </div>
                            </>
                        }
                    </div>


                    {/* Guardian Details */}
                    {
                        IS_MINOR &&
                        <div>
                            <div className="col-12">
                                {/* Minor Info message */}
                                <p className={` e-text-onyx e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px e-border-radius-16 p-2 p-sm-3 e-bg-cosmic-latte my-3`} >
                                    Since the nominee is a minor (under 18 years), please provide the details of a guardian to complete the nomination process.
                                </p>
                            </div>

                            <div className='row gx-gy-32px'>
                                <div className="col-sm-6 col-lg-4">
                                    {/* Nominee name */}
                                    <div id={`guardian-name-${props.index}`}>
                                        <CustomTextInput label="Guardian name*"
                                            placeholder="John Doe"
                                            type="text"
                                            floatingLabel
                                            value={guardianName}
                                            errorMsg={guardianNameError}
                                            handleChange={_handleGuardianNameChange} />
                                    </div>
                                </div>

                                {/*Guardian Relationship */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`guardian-relation-${props.index}`}>
                                        <CustomTextInput label="Guardian relationship*"
                                            placeholder="Select relation"
                                            dropdown={true}
                                            type="text"
                                            floatingLabel
                                            isOpen={showGuardianRelationModal}
                                            value={selectedGuardianRelation.name}
                                            errorMsg={guardianRelationError}
                                            readOnly
                                            className="cursor-pointer"
                                            onClick={() => _handleShowGuardianRelationModal()} />
                                    </div>
                                </div>

                                {/* ID Proof type */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`guardian-id-proof-type-${props.index}`}>
                                        <CustomTextInput label="Guardian ID proof*"
                                            placeholder="Select"
                                            dropdown={true}
                                            type="text"
                                            floatingLabel
                                            isOpen={showIDProofModal}
                                            value={guardianIDProof?.display_name}
                                            errorMsg={selectedGuardianIdProofError}
                                            readOnly
                                            className="w-100 cursor-pointer"
                                            onClick={() => _showProofModal('guardian')} />
                                    </div>
                                </div>

                                {/* ID Proof No*/}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`guardian-id-proof-number-${props.index}`}>
                                        <CustomTextInput label={proofLabelGuardian}
                                            placeholder="Enter ID proof no."
                                            floatingLabel
                                            type={guardianIDProof?.name === "aadhaar" ? "number" : "text"}
                                            maxLength={guardianIDProof?.name === "aadhaar" ? 4 : ""}
                                            value={guardianProofNo}
                                            errorMsg={guardianProofError}
                                            handleChange={(value) => _handleIDProofNumberChange(value, true)} />
                                    </div>
                                </div>

                                {/* Phone number */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`guardian-phone-number-${props.index}`}>
                                        <CustomPhoneInput label="Guardian mobile number*"
                                            id={`guardian-phone-input-${props.index}`}
                                            placeholder="9876543210"
                                            type="text"
                                            floatingLabel
                                            noScrollId={props.type}
                                            value={guardianPhone}
                                            selectedCountryCode={selectedGuardianCountryCode}
                                            selectedCountryLocale={selectedGuardianCountryLocale}
                                            error={guardianPhoneError}
                                            handleChange={(value, selected_country_code, country_locale) => _handlePhoneNumberChange(value, selected_country_code, country_locale, true)} />
                                    </div>
                                </div>

                                {/* Email ID */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`gurdian-email-${props.index}`}>
                                        <CustomTextInput label="Guardian email*"
                                            placeholder="Eg: emailaddress@gmail.com"
                                            type="text"
                                            floatingLabel
                                            value={guardianEmail}
                                            errorMsg={guardianEmailError}
                                            handleChange={(value) => _handleEmailChange(value, true)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }


                    <div className="col-auto">
                        <div className='d-flex align-items-center gap-2 mt-3'>
                            <img src={hasSameAddress ? ActiveCheckbox : Inactive}
                                draggable={false}
                                className='cursor-pointer width-24px width-20px-res'
                                alt='checkbox'
                                onClick={_handleHasSameAddress} />
                            <p className='mb-0 e-text-raisin-black_80 e-font-14 e-alt-font-poppins e-font-weight-500 line-height-20px   '>
                                Same as my address
                            </p>
                        </div>
                    </div>


                    {/* Address Detail - Nominee || Guardian */}
                    {
                        hasSameAddress === false &&
                        <>
                            <h3 className={`${props.type === 2 ? "col-12 mt-2 mt-sm-3" : "mt-sm-4 mt-2"} mb-3  e-text-chinese-black e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px`}>
                                {IS_MINOR ? "Gaurdian address details" : " Address details"}
                            </h3>
                            <div className='row gx-gy-32px'>

                                {/* address line  */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`address-${props.index}`}>
                                        <CustomTextInput label={"Address line 1*"}
                                            placeholder="202,Madhav Apts, jawar road......."
                                            type="text"
                                            inputType="alphanumeric"
                                            maxLength={250}
                                            floatingLabel
                                            value={IS_MINOR ? guardianAddress : address}
                                            errorMsg={IS_MINOR ? guardianAddressError : addressError}
                                            handleChange={(value) => _handleAddressChange(value, IS_MINOR)} />
                                    </div>
                                </div>

                                {/* address line 2  */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`address2-${props.index}`}>
                                        <CustomTextInput label={"Address line 2*"}
                                            placeholder="202,Madhav Apts, jawar road......."
                                            type="text"
                                            inputType="alphanumeric"
                                            maxLength={250}
                                            floatingLabel
                                            value={IS_MINOR ? guardianSecondAddress : secondAddress}
                                            errorMsg={IS_MINOR ? guardianSecondAddressError : secondAddressError}
                                            handleChange={(value) => _handleSecondAddressChange(value, IS_MINOR)} />
                                    </div>
                                </div>

                                {/* Nationality select */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`nationality-${props.index}`}>
                                        <CustomTextInput label="Country*"
                                            placeholder="India"
                                            dropdown={true}
                                            type="text"
                                            floatingLabel
                                            isOpen={showCountryModal}
                                            value={IS_MINOR ? guardianCountry.name : country.name}
                                            errorMsg={IS_MINOR ? guardianCountryError : countryError}
                                            readOnly
                                            onClick={() => _handleShowCountryModal(IS_MINOR ? 'guardian' : 'nominee')} />
                                    </div>
                                </div>

                                {/* state */}
                                <div className="col-sm-6 col-lg-4">
                                    <div id={`state-${props.index}`}>
                                        {
                                            (IS_MINOR ? guardianCountry?.id === 251 || guardianCountry.length === 0 : country?.id === 251 || country.length === 0) ?
                                                <CustomTextInput label={"State*"}
                                                    placeholder="Karnataka"
                                                    dropdown={true}
                                                    type="text"
                                                    floatingLabel
                                                    value={IS_MINOR ? selectedGuardianState.name : selectedState.name}
                                                    errorMsg={IS_MINOR ? selectedGuardianStateError : stateError}
                                                    readOnly
                                                    isOpen={showStateModal}
                                                    disabled={stateData.length === 0 ? true : false}
                                                    className=" cursor-pointer"
                                                    onClick={() => _openStateModal(IS_MINOR ? 'guardian' : 'nominee')}
                                                />
                                                :
                                                <CustomTextInput label={"State*"}
                                                    placeholder="Washington"
                                                    type="text"
                                                    inputType="alphanumeric"
                                                    floatingLabel
                                                    maxLength={100}
                                                    value={IS_MINOR ? selectedGuardianState : selectedState}
                                                    errorMsg={IS_MINOR ? selectedGuardianStateError : stateError}
                                                    handleChange={_handleChangeState}
                                                />
                                        }
                                    </div>
                                </div>

                                {/*select city*/}
                                <div className="col-sm-6 col-lg-4">
                                    {
                                        (IS_MINOR ? guardianCountry?.id === 251 || guardianCountry.length === 0 : country?.id === 251 || country.length === 0) ?

                                            <div id={`city-${props.index}`}
                                                className={`${IS_MINOR ? (selectedGuardianState.id ? "" : "e-disable") : selectedState.id ? "" : "e-disable"}`}>
                                                <CustomTextInput label="City*"
                                                    placeholder="Bangalore"
                                                    dropdown={true}
                                                    type="text"
                                                    floatingLabel
                                                    value={IS_MINOR ? selectedGuardianCity.name : selectedCity.name}
                                                    errorMsg={IS_MINOR ? guardianCityError : cityError}
                                                    readOnly
                                                    isOpen={showCityModal}
                                                    disabled={cityData.length !== 0 ? false : true}
                                                    className={`${IS_MINOR ? guardianCountry?.id === 251 : country?.id === 251 ? "cursor-pointer" : ""} w-100 px-3 pe-sm-3 pe-2 padding-12px-top padding-12px-bottom cursor-pointer`}
                                                    labelStyle="e-font-weight-500"
                                                    onClick={() => _openCityModal(IS_MINOR ? 'guardian' : 'nominee')} />
                                            </div>
                                            :
                                            <div id={`city-${props.index}`}>
                                                <CustomTextInput label="City*"
                                                    placeholder="Seattle"
                                                    type="text"
                                                    inputType="alphanumeric"
                                                    maxLength={100}
                                                    floatingLabel
                                                    value={IS_MINOR ? selectedGuardianCity : selectedCity}
                                                    errorMsg={IS_MINOR ? guardianCityError : cityError}
                                                    className={` w-100 px-3 pe-sm-3 pe-2 padding-12px-top padding-12px-bottom`}
                                                    labelStyle="e-font-weight-500"
                                                    handleChange={_handleChangeCity} />
                                            </div>
                                    }
                                </div>

                                <div className="col-sm-6 col-lg-4">
                                    {
                                        IS_MINOR ?
                                            <div id={`pincode-${props.index}`}>
                                                <CustomTextInput label={guardianCountry?.id === 251 || guardianCountry.length === 0 ? "Pincode*" : "ZipCode*"}
                                                    placeholder="670676"
                                                    type="number"
                                                    inputType="pincode"
                                                    floatingLabel
                                                    value={guardianPinCode}
                                                    errorMsg={guardianPinCodeError}
                                                    maxLength={guardianCountry?.id === 251 || guardianCountry.length === 0 ? 6 : 10}
                                                    className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                                    labelStyle="e-font-weight-500"
                                                    handleChange={(value) => _handlePinChange(value, 'guardian')} />
                                            </div>
                                            :
                                            <div id={`pincode-${props.index}`}>
                                                <CustomTextInput label={(country?.id === 251 || country.length === 0) ? "Pincode*" : "ZipCode*"}
                                                    placeholder="670676"
                                                    type={(country?.id === 251 || country.length === 0) ? "number" : "text"}
                                                    inputType={(country?.id === 251 || country.length === 0) ? "pincode" : "alphanumeric"}
                                                    floatingLabel
                                                    value={pinCode}
                                                    errorMsg={pinCodeError}
                                                    maxLength={(country?.id === 251 || country.length === 0) ? 6 : 10}
                                                    className="w-100 px-3 padding-12px-top padding-12px-bottom"
                                                    labelStyle="e-font-weight-500"
                                                    handleChange={(value) => _handlePinChange(value, 'nominee')} />
                                            </div>
                                    }
                                </div>




                            </div>
                        </>
                    }

                    {/* relation modal */}
                    {
                        showRelationModal &&
                        <SelectionSuggestModal title="Choose a relation*"
                            data={relationData.kyc_relationship}
                            type={props.index}
                            id={`select-suggest-modal${props.index}`}
                            selectedOption={selectedRelation}
                            onSelectOption={_handleSelectRelation}
                            onModalClose={() => setShowRelationModal(false)} />
                    }

                    {/* relation modal */}

                    {
                        showGuardianRelationModal &&
                        <SelectionSuggestModal title="Choose a guardian relation*"
                            data={relationData.nominee_minor_relation}
                            type={2}
                            id={`select-guardian-relation${props.index}`}
                            selectedOption={selectedGuardianRelation}
                            onSelectOption={_handleSelectGuardianRelation}
                            onModalClose={() => setShowGuardianRelationModal(false)} />
                    }

                    {/* ID Proof modal */}
                    {
                        showIDProofModal &&
                        <SelectionSuggestModal title="Choose a ID proof*"
                            // data={relationData.kyc_relationship}
                            data={ID_PROOF}
                            type={props.index}
                            id={`select-id-proof-${props.index}`}
                            selectedOption={IS_MINOR ? guardianIDProof : selectedIDProof}
                            onSelectOption={_handleSelectIDProof}
                            onModalClose={() => setShowIDProofModal(false)} />
                    }


                    {/* Country select */}
                    {
                        showCountryModal &&
                        <SelectionSuggestModal title="Choose a country"
                            data={countryData}
                            search
                            searchPlaceholder={"Eg : India"}
                            type={props.index}
                            id={`nominee-country-modal-${props.index}`}
                            selectedOption={IS_MINOR ? guardianCountry : country}
                            onSelectOption={_handleSelectNomineeNation}
                            onModalClose={() => setShowCountryModal(false)} />
                    }

                    {/* State modal*/}
                    {
                        showStateModal &&
                        <SelectionSuggestModal title="Choose a state"
                            data={stateData}
                            type={props.index}
                            search={true}
                            id={`nominee-state-modal-${props.index}`}
                            searchPlaceholder={"Eg : Karnataka"}
                            selectedOption={nomineeType === 'nominee' ? selectedState : selectedGuardianState}
                            onSelectOption={_handleSelectState}
                            onModalClose={() => setShowStateModal(false)} />
                    }

                    {/* city modal */}
                    {
                        showCityModal &&
                        <SelectionSuggestModal title="Choose a city"
                            data={cityData}
                            type={props.index}
                            search={true}
                            searchPlaceholder={"Eg : Bangalore"}
                            id={`nominee-city-modal-${props.index}`}
                            selectedOption={nomineeType === 'nominee' ? selectedCity : selectedGuardianCity}
                            onSelectOption={_handleSelectCity}
                            onModalClose={() => setShowCityModal(false)} />
                    }



                </>
            }
        </>
    )
}


export default memo(AddNomineeCard);

AddNomineeCard.defaultProps = {
    onChange: () => { },
    type: 1
}